module.exports = __webpack_public_path__ + "img/111.2.45257dde.png";